import type { PropsWithChildren } from 'react';

import { VBasePopover } from '../VBasePopover';
import style from './style';
import type { TooltipProps } from './type';

const VTooltip = ({
  content,
  placement,
  visible,
  children,
}: PropsWithChildren<TooltipProps>) => {
  return (
    <VBasePopover
      className="border-black!"
      content={() => <VTooltipContent content={content} />}
      placement={placement}
      trigger="hover"
      visible={visible}
    >
      {children}
    </VBasePopover>
  );
};

const VTooltipContent = ({ content }: Pick<TooltipProps, 'content'>) => {
  return (
    <div className={style.tooltipContent}>
      {typeof content === 'function' ? content() : content}
    </div>
  );
};

VTooltipContent.displayName = 'VTooltipContent';

export default VTooltip;
